import { render, staticRenderFns } from "./OfferDescription.vue?vue&type=template&id=66c7c5d4&scoped=true"
import script from "./OfferDescription.vue?vue&type=script&lang=ts"
export * from "./OfferDescription.vue?vue&type=script&lang=ts"
import style0 from "./OfferDescription.vue?vue&type=style&index=0&id=66c7c5d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c7c5d4",
  null
  
)

export default component.exports